import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";var _excluded = ["headerText", "children", "icon"];import { GridLegacy as Grid } from '@mui/material'; //Grid2 is now recommended and has replaced Grid. GridLegacy is the original component.
import React from 'react';
import { DataCard_Header, DataCard_Root } from './DataCard.style';
import { DataCardBody_Root } from './DataCardBody.style';

/**
 * @typedef DataCardProps
 * @property {React.ReactNode} [headerText] The header text.
 * @property {React.ReactNode} [icon] The icon element to be rendered to the left of the header.
 */

/** @type {(props: DataCardProps & React.HTMLAttributes<HTMLDivElement>) => JSX.Element} */
export function DataCard(_ref)




{var headerText = _ref.headerText,children = _ref.children,icon = _ref.icon,otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(
    React.createElement(DataCard_Root, otherProps, /*#__PURE__*/
    React.createElement(DataCard_Header, null,
    icon, " ", headerText
    ), /*#__PURE__*/
    React.createElement(DataCardBody_Root, null, /*#__PURE__*/
    React.createElement(Grid, {
      container: true,
      spacing: 2 },

    children
    )
    )
    ));

}
//# sourceMappingURL=DataCard.js.map